export const corporations = {
  Add_a_New_Company: "Add a New Company",
  Add_Another_Admin: "Add Another Admin",
  Add_Company: "Add Company",
  Add_new_company: "Add new company",
  Companies: "Companies",
  company_management: "company management",
  Company_name: "Company name",
  "Created at": "Created at",
  Edit_Company: "Edit Company",
  Name: "Name",
  Organisation_Admins: "Organisation Admins",
  Please_enter_the_basic_company_information: "Please enter the basic company information",
  Status: "Status",
  Update_company: "Update company",
  Use_this_window_to_add_a_new_company_data_on_the_platform:
    "Use this window to add a new company data on the platform",
  Use_this_window_to_edit_company_data_on_the_platform: "Use this window to edit company data on the platform",
} as const;
